import {Component} from "@angular/core";
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {FraisMissionListeItem} from "@domain/admin/frais/indemnites/frais-mission-liste-item";

/**
 * Composant d'affichage d'un frais de mission dans la liste
 */
@Component({
    host: {'data-test-id': 'indemnites-frais-missions-list-item'},
    selector: 'indemnites-frais-missions-list-item',
    templateUrl: './indemnites-frais-missions-list-item.component.html',
    styleUrls: ['./indemnites-frais-missions-list-item.component.scss']
})
export class IndemnitesFraisMissionsListItemComponent extends ListViewItem<FraisMissionListeItem> {
    /**
     * Consultation du frais de mission courant
     */
    consultFraisMission(item?: FraisMissionListeItem): void {
        const target = item ?? this.data;
        this.extraOptions?.consultFraisMission?.(target);
    }
}